module.exports = __webpack_public_path__ + "assets/img/00072.b00b9e71.png";